import { text2time, isArray, forEach } from '../../../../utils/base'

function _matchConfig(state, cId) {
  const { matchConfigs } = state
  return matchConfigs && matchConfigs[cId] ? matchConfigs[cId] : null
}

export default {
  beginTime(state) {
    const { baseConf } = state
    if (baseConf && baseConf.begin) {
      return text2time(baseConf.begin)
    }
    return 0
  },
  endTime(state) {
    const { baseConf } = state
    if (baseConf && baseConf.end) {
      return text2time(baseConf.end)
    }
    return 0
  },

  // 单个比赛配置
  matchOf(state) {
    return cId => _matchConfig(state, cId)
  },

  // 单个擂台信息
  cupOf(state) {
    return cId => {
      const { matchConfigs } = state
      const matchInfo = matchConfigs ? matchConfigs[cId] : null
      if (matchInfo && isArray(matchInfo.cupList)) {
        return matchInfo.cupList[0] || null
      }
      return null
    }
  },

  // 比赛列表
  matchList(state, getters) {
    const { cIds } = state
    const list = []
    console.log(cIds.join())
    forEach(cIds, cId => {
      const match = getters.matchOf(cId)
      const cup = getters.cupOf(cId)
      if (match && cup) {
        const { cupName } = cup
        list.push({
          ...match,
          cup,
          cupName
        })
      }
    })
    console.log(list)
    return list
  }
}
